<div
  class="progress-tracker-container"
  [matTooltip]="tooltipText()"
  [matTooltipDisabled]="!tooltipText()"
>
  <div class="progress-header" *ngIf="label()">
    <span class="progress-label">{{ label() }}</span>
    <span class="progress-percentage" *ngIf="showPercentage()"
      >{{ displayProgress }}%</span
    >
  </div>

  <div class="progress-bar-container">
    <div
      class="progress-bar-background"
      [class.pulsating]="
        animateProgress() &&
        !isComplete &&
        status()?.toString() == 'in_progress'
      "
    ></div>
    <mat-progress-bar
      [color]="statusColor"
      [mode]="
        status()?.toString() === 'pending' ? 'indeterminate' : 'determinate'
      "
      [value]="displayProgress"
      [ngStyle]="progressBarStyle"
    ></mat-progress-bar>
    @if (showRunningIndicator) {
      <div class="running-indicator" [ngStyle]="runningIndicatorStyle">
        <div class="car" aria-hidden="true">
          <span class="car-dust dust-1"></span>
          <span class="car-dust dust-2"></span>
          <span class="car-dust dust-3"></span>
          <span class="car-body"></span>
          <span class="car-cabin"></span>
          <span class="car-window"></span>
          <span class="car-wheel front"></span>
          <span class="car-wheel back"></span>
        </div>
      </div>
    }
    <div
      class="status-icon"
      *ngIf="status()?.toString() !== 'in_progress' || progress() === 100"
    >
      <mat-icon [ngClass]="statusColor">{{ statusIcon }}</mat-icon>
    </div>
  </div>
  <div class="progress-footer" *ngIf="!label() && showPercentage()">
    <span class="progress-percentage">{{ displayProgress }}%</span>
  </div>

  <div class="progress-footer extra-label" *ngIf="extraLabel()">
    <span class="progress-percentage">{{ extraLabel() }}</span>
  </div>
</div>
